import { useNavigate, useSearchParams } from 'react-router-dom'

export enum PageType {
  LANDING = 'LANDING',
  DISCOVERY = 'DISCOVERY',
  PDC = 'PDC',
  ROUTE_PLANNER = 'ROUTE_PLANNER',
  COLLECTIONS_LIST = 'COLLECTIONS_LIST',
  COLLECTION_PLACES = 'COLLECTION_PLACES',
}
export interface Page {
  type: PageType
  url: string
}

export const initialState = {
  type: PageType.LANDING,
  url: '/',
}

let history = [initialState]

interface UseNavigationResult {
  goBack: () => void
  goTo: (page: Page) => void
}

export const useNavigation = (): UseNavigationResult => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const mapSearchParamStr = searchParams.get('map')

  const goBack = (): void => {
    const newHistory = [...history]

    if (history.length > 1) {
      newHistory.pop()
      history = newHistory
    }

    const currentPage = newHistory[newHistory.length - 1]

    if (currentPage.type === PageType.LANDING && mapSearchParamStr !== null) {
      navigate(`${currentPage.url}?map=${mapSearchParamStr}`)

      return
    }

    navigate(currentPage.url)
  }

  const goTo = (page: Page): void => {
    const historyClone = [...history]
    const current = historyClone[historyClone.length - 1]
    let replace = false

    if (current.type === page.type) {
      historyClone[historyClone.length - 1] = page
      replace = true
    } else {
      historyClone.push(page)
    }

    history = [...historyClone]

    if (mapSearchParamStr !== null) {
      navigate(`${page.url}?map=${mapSearchParamStr}`, { replace })

      return
    }

    navigate(page.url, { replace })
  }

  return { goBack, goTo }
}
